export const parseQuery = (query: Record<any, any>) =>
  new URLSearchParams(query).toString();
